module.exports = __webpack_public_path__ + "static/media/18ECA34.091204f9.jpg";